__turbopack_context__.v({
  "authCard": "auth-module__89pphG__authCard",
  "authCardWide": "auth-module__89pphG__authCardWide",
  "authError": "auth-module__89pphG__authError",
  "authFooterText": "auth-module__89pphG__authFooterText",
  "authForm": "auth-module__89pphG__authForm",
  "authImage": "auth-module__89pphG__authImage",
  "authPage": "auth-module__89pphG__authPage",
  "authSubtitle": "auth-module__89pphG__authSubtitle",
  "authSuccess": "auth-module__89pphG__authSuccess",
  "forgotActions": "auth-module__89pphG__forgotActions",
  "forgotLink": "auth-module__89pphG__forgotLink",
  "formGroup": "auth-module__89pphG__formGroup",
  "formOptions": "auth-module__89pphG__formOptions",
  "imagePlaceholder": "auth-module__89pphG__imagePlaceholder",
  "passwordToggleBtn": "auth-module__89pphG__passwordToggleBtn",
  "remember": "auth-module__89pphG__remember",
});
